const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/achievements.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { httpClient } from "@/lib/http-client";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
  locale: string | undefined;
};
export const Route = createFileRoute("/{-$locale}/offers/$id/achievements")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      locale
    } = context;
    const {
      id
    } = params;
    await queryClient.prefetchQuery({
      queryKey: ["offer-achievements", {
        id
      }],
      queryFn: () => httpClient.get<AchievementsSets>(`/offers/${id}/achievements`).catch(() => [])
    });
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(params.id, locale));
    return {
      id,
      locale,
      dehydratedState: dehydrate(queryClient),
      offer
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, [...offerOnlyQueryOptions(params.id, ctx.loaderData?.locale).queryKey]);
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, "Achievements")
    };
  }
});